__turbopack_context__.v({
  "className": "inter_1b8c04d1-module__Gj4uHq__className",
  "variable": "inter_1b8c04d1-module__Gj4uHq__variable",
});
